export const memberGetKey = (memberId: string | undefined) => (memberId ? ['members.search.id', memberId] : null);
